// Constants
import {
  OTHER_REASON_FIELD,
  REASON_DROPDOWN_FIELD,
  SUPPORT_TICKET_FIELD,
  TEST_CHANGES_DETAILS_FIELD,
  SCREEN_SHARE_DETAILS_FIELD,
  AGENT_FIELD,
  IMPERSONATION_SCHEMA,
  ORG_FIELD,
} from 'app/modules/navigator/schema';

// Components
import {
  U21Form,
  U21FormField,
  U21Modal,
  U21Spacer,
} from 'app/shared/u21-ui/components';

// Models
import { AuthClient } from 'app/modules/session/models';
import { ImpersonationFormValues } from 'app/modules/navigator/models';

// Queries
import { useStartImpersonation } from 'app/modules/impersonation/queries/useStartImpersonation';
import { useGetOrgOptions } from 'app/modules/orgManagement/queries/useGetOrgs';

// Utils
import {
  createFormInitialValues,
  generateFormFieldProps,
} from 'app/shared/utils/form';
import { IconAffiliate } from '@u21/tabler-icons';
import { AgentField } from 'app/modules/impersonation/components/AgentField';

const initialValues =
  createFormInitialValues<ImpersonationFormValues>(IMPERSONATION_SCHEMA);

interface AccountImpersonationModalProps {
  open: boolean;
  handleClose: () => void;
  auth: AuthClient;
}

const FORM_ID = 'impersonation-form';

export const AccountImpersonationModal = ({
  open,
  handleClose,
  auth,
}: AccountImpersonationModalProps) => {
  const { data: orgOptions = [] } = useGetOrgOptions({ enabled: open });

  const { mutate: startImpersonation, isPending: impersonationLoading } =
    useStartImpersonation(auth, handleClose);

  return (
    <U21Modal
      open={open}
      onClose={handleClose}
      title="Impersonate"
      actionButtonProps={{
        children: 'Confirm Impersonation',
        form: FORM_ID,
        loading: impersonationLoading,
        type: 'submit',
      }}
    >
      <U21Form
        id={FORM_ID}
        initialValues={initialValues}
        onSubmit={(model) => {
          startImpersonation(model);
        }}
      >
        {(formProps) => {
          const {
            values,
            form: {
              mutators: { setFieldValueUntyped },
            },
          } = formProps;
          return (
            <U21Spacer spacing={2}>
              <U21FormField
                {...generateFormFieldProps(ORG_FIELD)}
                fieldProps={{
                  startIcon: <IconAffiliate />,
                  options: orgOptions,
                  autoFocus: true,
                  placeholder: 'Select organization',
                  onChange: () => {
                    setFieldValueUntyped(AGENT_FIELD.name, undefined);
                  },
                  loading: !orgOptions.length,
                }}
              />
              <AgentField />
              <U21FormField
                {...generateFormFieldProps(REASON_DROPDOWN_FIELD)}
              />
              {values.impersonation_reason === 'SUPPORT_TICKET' && (
                <U21FormField
                  {...generateFormFieldProps(SUPPORT_TICKET_FIELD)}
                />
              )}
              {(values.impersonation_reason === 'OTHER' ||
                values.impersonation_reason === 'SUPPORT_TICKET') && (
                <U21FormField {...generateFormFieldProps(OTHER_REASON_FIELD)} />
              )}
              {values.impersonation_reason === 'VIEW_CHANGES' && (
                <U21FormField
                  {...generateFormFieldProps(TEST_CHANGES_DETAILS_FIELD)}
                />
              )}
              {values.impersonation_reason === 'SCREEN_SHARE' && (
                <U21FormField
                  {...generateFormFieldProps(SCREEN_SHARE_DETAILS_FIELD)}
                />
              )}
            </U21Spacer>
          );
        }}
      </U21Form>
    </U21Modal>
  );
};
